import { Component, Inject, Injectable, Input, OnInit, PLATFORM_ID } from "@angular/core";
import { BrowserDetectorService } from 'src/app/data/networking/services/shared/broswer-detector/browser-detector.service';
import { Router } from '@angular/router';
import { Subscription, timer } from "rxjs";
import { ProductInterface } from "src/app/data/networking/models/shared/responses/product-response";
import { ProductCardVm } from "src/app/view-model/product-card/product-card.vm";
import { PrimeSubscription } from "src/app/data/networking/models/prime/prime";
import { AppState } from "src/app/app.reducer";
import { Store } from "@ngrx/store";
import { isPlatformBrowser } from "@angular/common";
import { primeStyles } from "src/app/data/networking/models/product/responses/products";

@Component({
  selector: 'app-flash-offer',
  templateUrl: './flash-offer.component.html',
  styleUrls: ['./flash-offer.component.scss'],
})
export class FlashOfferComponent implements OnInit {
  constructor(
    public router: Router,
    private browserDetectorService: BrowserDetectorService,
    private vm: ProductCardVm,
    private store: Store<AppState>,
    @Inject(PLATFORM_ID) platformId
  ) {
    this.isBrowser = isPlatformBrowser(platformId) && (navigator.userAgent.indexOf('Chrome-Lighthouse') === -1);
  }
  @Input() idPrefix = '';
  @Input() product: ProductInterface;
  @Input() isMini = false;
  @Input() isHome = false;
  @Input() isVTO = false;
  @Input() isLorealDesign = false;
  @Input() isFlashOffer = false;
  @Input() lazyLoaded = false;
  @Input() isAlgolia = false;
  @Input() isSustitutes = false;
  @Input() queryID = '';
  @Input() positions = '';
  @Input() subs:Subscription[] = [];
  public withoutStock = false;
  stockAlert = false;
  valuePercentageBar;
  browser = this.browserDetectorService.checkBrowser();
  offerSecond = 1000;
  offerMinute = this.offerSecond * 60;
  offerHour = this.offerMinute * 60;
  offerDay = this.offerHour * 24;
  hours = 0;
  day = 0;
  minutes = 0;
  seconds = 0;
  clock: Subscription;
  now: Date;
  end: number;
  source = timer(0, 1000);
  isBrowser = false;
  primeData:PrimeSubscription;
  primeStyles:primeStyles;
  offerExpire = false;

  ngOnInit(): void {
    this.store.select('prime')
      .subscribe(({ config }) => {
        if (!config?.length) return;
        this.primeStyles = config[0];
        this.vm.getPrimeSubscription().subscribe(
          res => {
            this.primeData = res;
          })
      });
    this.progressBarUnitProgress();
  }

  progressBarUnitProgress() {
    if (this.product?.braze) {
      const totalPercent=100;
      const stockLimit=8;
      const stockFlashPercent = this.product?.braze.extras.availableStockFlash * totalPercent;
      const stockFlashTotal = this.product?.braze.extras.totalStockFlash;
      const percentage = (Number(stockFlashPercent) / Number(stockFlashTotal));
      const numberPercentage = Math.round(percentage);
      const totalPercentage = totalPercent - numberPercentage;
      this.valuePercentageBar = `${totalPercentage}%`;
      if (this.valuePercentageBar === `${totalPercent}%`) {
        this.withoutStock = true;
      }
      if (this.product?.braze.extras.availableStockFlash <= stockLimit) {
        this.stockAlert = true;
      }
      if (this.isFlashOffer) {
        this.clock = this.source.subscribe(() => {
          this.now = new Date();
          const endDate = parseInt(this.product?.braze.extras.endDate);
          this.end = endDate;
          this.showDate();
        });
        this.subs.push(this.clock);
      }
    }
  }

  showDate() {
    const distance = this.end - this.now.getTime();
    if(distance<0){
      this.offerExpire=true;
    }
    this.day = Math.floor(distance / this.offerDay);
    this.hours = Math.floor((distance % this.offerDay) / this.offerHour);
    this.minutes = Math.floor((distance % this.offerHour) / this.offerMinute);
    this.seconds = Math.floor((distance % this.offerMinute) / this.offerSecond);
  }

  goDetail(product:ProductInterface) {
    this.router.navigate([`/producto/${product?.id}-${product?.seoUrl}`]);
  }
  showPrice():boolean {
    return !this.primeData?.active || !this.product.primePrice || this.product.primePrice == 0;
  }
  showPriceText():number {
    return this.product?.offerPrice > 0 ? this.product.offerPrice : this.product.fullPrice;
  }
  showOfferPrice():boolean {
    const priceOffer = !this.primeData?.active || !this.product.primePrice || this.product.primePrice == 0;
    const pricePrime = this.primeData?.active || this.product.primePrice > 0;
    return priceOffer || pricePrime;
  }
  showContainerPetal():boolean{
    return this.product.primeTextDiscount && this.product.primePrice && !this.primeData?.active;
  }
  showPrimePetal():boolean{
    return (this.primeData && this.primeStyles?.feature_active_web && !this.primeData.active);
  }
  hideRating():boolean{
    return (this.product.deliveryTime && this.product.deliveryTime.search('min') === -1 );
  }
  offerTime(stockAlert?:boolean): boolean{
    if(stockAlert){
      return (this.day <= 0 && this.hours <= 1) || this.stockAlert;
    }else{
      return (this.day > 0 || this.hours > 1) && !this.stockAlert;
    }
  }

  goToGroup():void {
    if (this.product.deepLinkRedirectUrl && this.product.type === 'GROUP') {
      if (this.isBrowser) {
        window.open(this.product.deepLinkRedirectUrl, '_self');
      }
    }

    if (this.product.url && !this.product.deepLinkRedirectUrl) {
      this.router.navigate([this.product.url]);
    }

  }
}